"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _FavoritesHeartIconButton = require("./FavoritesHeartIconButton");
Object.keys(_FavoritesHeartIconButton).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _FavoritesHeartIconButton[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _FavoritesHeartIconButton[key];
    }
  });
});
var _types = require("./types");
Object.keys(_types).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _types[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _types[key];
    }
  });
});
